export default {
  title: {
    fontFamily: 'SackersGothicStd, sans-serif'
  },
  preTitle: {
    fontFamily: 'SackersGothicStd, sans-serif',
    fontSize: '20px',
    'screen-small-max': {
      fontSize: '16px',
      lineHeight: '24px',
    }
  },
  centerSaleTitle: {},
  centerSaleSubtitle: {},
  contentContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    'screen-large': {
      padding: '32px 70px'
    }
  },
  additionalBackgroundPictureStyles: {
    height: '260px',
    'screen-large': {
      height: '292px'
    }
  }
}
